import React from 'react'
import { MDBTable, MDBTableBody } from 'mdbreact';
import BotonesFormulario from '../componentes/BotonesFormulario'
import HeaderTabla from '../componentes/HeaderTabla'
//import TraeNombre from '../hooks/useTraeNombre'
import { TraeNombre } from '../hooks/Funciones'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons' // <-- import styles to be used


const VerAprobados = ({ data, seleccionaRegistro, baseUrl }) => {

	return (
		<MDBTable hover responsive>
			<HeaderTabla array={['Id', 'Estado', 'Tipo', 'Puntaje', 'Curso', 'Usuario', '']} />
			<MDBTableBody>

				{data.map((item, index) => {
					return (
						<tr key={index} className="tabla_productos">
							<td>{item.id}</td>
							<td><span className={`estados ${item.estado}`}>{item.estado}</span></td>
							<td>{item.tipo}</td>
							<td>{item.puntaje}</td>
							<td>{item.nombreCurso}</td>
							<td>{item.nombre}</td>
							<td className="tabla_funciones">
								<BotonesFormulario SeleccionarCategoria={seleccionaRegistro} item={item} Roll={'Admin'} />
							</td>
						</tr>
					)
				})}

			</MDBTableBody>
		</MDBTable>
	)
}

export default VerAprobados